import { Blocks } from 'lucide-react';

export default function AdminIntegrations() {
  return (
    <div>
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 dark:bg-primary-900/50">
          <Blocks className="h-5 w-5 text-primary-600 dark:text-primary-400" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Integrations
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Connect third-party services to extend portal functionality.
          </p>
        </div>
      </div>

      {/* Placeholder */}
      <div className="rounded-lg bg-white dark:bg-gray-800 shadow">
        <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
            <Blocks className="h-7 w-7 text-gray-400 dark:text-gray-500" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">
            Coming Soon
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 max-w-sm">
            Integrations with third-party services like email delivery, notifications, and AI-powered analysis are on the roadmap.
          </p>
        </div>
      </div>
    </div>
  );
}
